import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TranslationTable from './TranslationTable';
import { createTranslationTable, updateTranslationTable, fetchTranslationTable } from 'redux/translationTable/TranslationTableActions';

const mapStateToProps = ({ translationTable }) => ({
  translationTable: translationTable.translationTable,
  sourceColumns: translationTable.sourceColumns,
  targetColumn: translationTable.targetColumn,
  translationTableEditionMode: translationTable.translationTableEditionMode,
  fetchingTranslationTable: translationTable.fetchingTranslationTable
});

const mapDispatchToProps = dispatch => ({
  ttActions: bindActionCreators({ createTranslationTable, updateTranslationTable, fetchTranslationTable }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(TranslationTable);



// WEBPACK FOOTER //
// ./src/shared/components/translationTable/TranslationTableConnector.js